<template>
	<!-- Skip Links for Keyboard Navigation — teleported before v-main for first-focus order -->
	<Teleport to="#skip-links-portal">
		<a href="#main-content" class="skip-link" @click.prevent="() => { const el = document.getElementById('main-content'); if (el) { el.focus(); } }">Skip to main content</a>
	</Teleport>
	
	<div class="w-100 bg-color-granite d-flex justify-center flex-column" aria-label="RISE Partner Home Dashboard" tabindex="-1" id="main-content" >
		<!-- Live region for dynamic content updates -->
		<div aria-live="polite" aria-atomic="true" class="sr-only" id="live-updates"></div>
			<div class="d-flex justify-center align-center w-100 position-relative" role="banner">
			<v-img class="w-100 h-100"		
				aspect-ratio="16/9"
				src="https://dellpartnerincentives.com/siteassets/Images/HomePartner/Banner/bgRISE2.jpg"
				alt="RISE Incentive Program welcome banner"
			></v-img>
			<div class="position-absolute page-header">
				<h1><LanguagePlaceholder default-text="Welcome to RISE" /></h1>
				<span><LanguagePlaceholder default-text="Elevate your rewards with every purchase" /></span>
			</div>			
		</div>
	<v-container class="d-flex justify-center bg-color-granite">
		<v-row no-gutters align="stretch" class="bg-color-granite w-auto">
			<v-col class="ga-2 d-flex flex-column">
					<v-sheet class="d-flex flex-column" id="about-rise">
						<div class="pa-2 bg-color-cobalt tx-color-white tx-font-bold text-center">
							<h2><LanguagePlaceholder default-text="About RISE" /></h2>
						</div>
						<div class="pa-2 bg-color-dell-blue tx-color-white tx-font-bold text-center">
							<LanguagePlaceholder default-text="The RISE Incentive Program rewards you for purchasing eligible Dell Technologies products with competitive $-per-box rewards, multipliers, and bonuses." />
						</div>
						<div class="d-flex justify-center pa-2 bg-color-dell-blue tx-color-white">
							<v-img class="d-flex justify-center align-center" cover
								src="https://dellpartnerincentives.com/siteassets/Images/HomePartner/bgAbout.png"
								alt="Earn up to $15,000 per incentive period promotional"
							>
								<div class="d-flex flex-column justify-center text-center pt-10">
									<span class="tx-font-size24 tx-font-normal">
										<LanguagePlaceholder is-html default-text="Earn up to" />
									</span>
									<span class="tx-font-size48 tx-font-bold">
										<LanguagePlaceholder is-html default-text="$15,000" />
									</span>
									<span class="tx-font-size24 tx-font-normal">
										<LanguagePlaceholder is-html default-text="per incentive period!" />
									</span>
								</div>
							</v-img>
						</div>
						<div class="px-2 pb-2 bg-color-cobalt tx-color-white tx-font-bold text-center">
							<v-btn class="text-none w-100 bg-color-royal" @click="systemStore.routerTo('home-about-rise-partner')" @keydown.enter="systemStore.routerTo('home-about-rise-partner')" aria-label="View more about RISE program" tabindex="0" role="link">
								<LanguagePlaceholder default-text="View More" />
							</v-btn>  
						</div>
          </v-sheet>
					<v-sheet class="d-flex flex-column mt-auto" style="min-height: 350px;" id="eligible-products">
						<div class="pa-2 bg-color-white tx-color-royal tx-font-bold text-center">
							<h2><LanguagePlaceholder default-text="Eligible Products" /></h2>
						</div>
						<div class="d-flex justify-center pa-2 bg-color-quartz tx-color-white">
							<v-img class="d-flex justify-center align-center" cover height="250px"
								src="https://dellpartnerincentives.com/siteassets/Images/HomePartner/EligibleProduct.jpg"
								alt=""
							></v-img>
						</div>
						<div class="px-2 pb-2 bg-color-quartz tx-color-white tx-font-bold text-center">
							<v-btn class="text-none w-100 bg-color-dell-blue" @click="systemStore.routerTo('home-eligible-products')" @keydown.enter="systemStore.routerTo('home-eligible-products')" aria-label="View eligible products list" tabindex="0" role="link">
								<LanguagePlaceholder default-text="View More" />
							</v-btn>  
						</div>
					</v-sheet>
				</v-col>

				<v-col cols="6" class="ga-2 mx-2 d-flex flex-column">
					<v-sheet class="d-flex flex-column" id="news-promotions">
						<div class="pa-2 bg-color-white tx-color-royal tx-font-bold text-center">
							<h2><LanguagePlaceholder default-text="News and Promotions" /></h2>
						</div>
						<div class="px-2 bg-color-white tx-color-steel text-start tx-font-bold tx-font-size14">
							<Carousel carousel-title="Welcome" :carousel-items="carouselOneItems"></Carousel>   
						</div>
						<div class="pa-2 bg-color-quartz tx-color-white tx-font-bold text-center">
							<v-btn class="text-none w-100 bg-color-dell-blue" @click="systemStore.routerTo('news')" @keydown.enter="systemStore.routerTo('news')" aria-label="View more news and promotions" tabindex="0" role="link">
								<LanguagePlaceholder default-text="View More" />
							</v-btn>    
						</div>
					</v-sheet>
					<v-sheet class="d-flex flex-column">
						<v-row no-gutters align="start" class="bg-color-granite w-auto d-flex ga-2">
							<v-col class="bg-color-quartz ga-2 d-flex flex-column" id="my-performance">
								<div class="pa-2 bg-color-white tx-color-royal tx-font-bold text-center">
									<h3><LanguagePlaceholder default-text="My Current Performance" /></h3>
								</div>
								<dl class="ma-0 pa-0">
								<v-row no-gutters class="divider bg-color-quartz tx-color-carbon tx-font-size12 tx-font-bold w-100 d-flex justify-space-between pt-1 pb-2">
										<dt class="ps-4" style="flex: 0 0 auto;">
										<LanguagePlaceholder is-html default-text="Core Rewards" />
										</dt>
									<dd class="text-end pe-4" style="flex: 0 0 auto; margin-left: auto;">
									{{ $filters.currencyUSD(totalDollarCoreRewards) }}
									</dd>
								</v-row>
								<v-row no-gutters class="divider bg-color-quartz tx-color-carbon tx-font-size12 tx-font-bold w-100 d-flex justify-space-between pt-1 pb-2">
										<dt class="ps-4" style="flex: 0 0 auto;">
										<LanguagePlaceholder is-html default-text="Bonus Rewards" />
										</dt>
										<dd class="text-end pe-4" style="flex: 0 0 auto; margin-left: auto;">
										{{ $filters.currencyUSD(totalDollarBonusRewards) }}
										</dd>
								</v-row>
								<v-row no-gutters class="divider bg-color-quartz tx-color-carbon tx-font-size12 tx-font-bold w-100 d-flex justify-space-between pt-1 pb-2">
										<dt class="ps-4" style="flex: 0 0 auto;">
										<LanguagePlaceholder is-html default-text="Total Rewards" />
										</dt>
										<dd class="text-end pe-4" style="flex: 0 0 auto; margin-left: auto;">
										{{ $filters.currencyUSD(totalDollarBonusRewards + totalDollarCoreRewards) }}
										</dd>
								</v-row>
								<v-row no-gutters class="bg-color-quartz tx-color-carbon tx-font-size12 tx-font-bold w-100 d-flex justify-space-between pt-1 pb-0">
										<dt class="ps-4" style="flex: 0 0 auto;">
										<LanguagePlaceholder is-html default-text="Total Qualifying Units" />
										</dt>
										<dd class="text-end pe-4" style="flex: 0 0 auto; margin-left: auto;">
										{{ myUnits }}
										</dd>
								</v-row>
								</dl>
								<div class="pa-2 bg-color-quartz tx-color-white tx-font-bold text-center">
									<v-btn class="text-none w-100 bg-color-dell-blue" @click="systemStore.routerTo('my-performance')" @keydown.enter="systemStore.routerTo('my-performance')" aria-label="View detailed performance report" tabindex="0" role="link">
										<LanguagePlaceholder default-text="View More" />
									</v-btn>  
								</div>
							</v-col>
							<v-col class="bg-color-quartz ga-2 d-flex flex-column" id="rewards-center">
								<div class="pa-2 bg-color-white tx-color-royal tx-font-bold text-center">
									<h3><LanguagePlaceholder default-text="Rewards Center" /></h3>
								</div>
								<dl class="ma-0 pa-0">
								<v-row no-gutters class="divider bg-color-quartz tx-color-carbon tx-font-size12 tx-font-bold w-100 d-flex justify-space-between pt-1 pb-2">
									<dt class="ps-4" style="flex: 0 0 auto;">
									<LanguagePlaceholder is-html default-text="Reward Type" />
									</dt>
									<dd class="text-end pe-4" style="flex: 0 0 auto; margin-left: auto;">
									{{ redemptionsCreditedProcess }}
									</dd>
								</v-row>
								<v-row no-gutters class="divider bg-color-quartz tx-color-carbon tx-font-size12 tx-font-bold w-100 d-flex justify-space-between pt-1 pb-2">
										<dt class="ps-4" style="flex: 0 0 auto;">
										<LanguagePlaceholder is-html default-text="Earned Rewards (Q3)" />
										</dt>
										<dd class="text-end pe-4" style="flex: 0 0 auto; margin-left: auto;">
										<span v-if="redemptionWindowOpen">
											<span v-if="redemptionsCreditedProcess === 'EVoucher' && redemptionsCredited > 0">
											{{ $filters.currencyUSD(redemptionsCredited) }}
											</span>
											<span v-else>
												{{ $filters.currencyUSD(redemptionsBalance) }}
											</span>
										</span>
										<span v-else>
											{{ $filters.currencyUSD(0) }}	
										</span>
										</dd>
								</v-row>
								
								<v-row no-gutters class="divider bg-color-quartz tx-color-carbon tx-font-size12 tx-font-bold w-100 d-flex justify-space-between pt-1 pb-2">
										<dt class="ps-4" style="flex: 0 0 auto;">
										<LanguagePlaceholder is-html default-text="Banked Rewards (Q2)" />
										</dt>
										<dd class="text-end pe-4" style="flex: 0 0 auto; margin-left: auto;">
										<span v-if="redemptionWindowOpen">
											<span v-if="redemptionsCreditedProcess === 'EVoucher' && redemptionSummaryData.banked > 0">
											{{ $filters.currencyUSD(redemptionSummaryData.banked) }}
											</span>
											<span v-else>
												{{ $filters.currencyUSD(redemptionSummaryData.banked) }}
											</span>
										</span>
										<span v-else>
											{{ $filters.currencyUSD(0) }}	
										</span>
										</dd>
								</v-row>
								<v-row no-gutters class="bg-color-quartz tx-color-carbon tx-font-size12 tx-font-bold w-100 d-flex justify-space-between pt-1 pb-0">
										<dt class="ps-4" style="flex: 0 0 auto;">
										<LanguagePlaceholder is-html default-text="Total Reward Balance" />
										</dt>
										<dd class="text-end pe-4" style="flex: 0 0 auto; margin-left: auto;">
										<span v-if="redemptionWindowOpen">
											<span v-if="redemptionsCreditedProcess === 'EVoucher' && redemptionsBalance >= 50  && !IsPassthroughCountry">
											{{ $filters.currencyUSD(redemptionsBalance) }}
											</span>
											<span v-else>
											{{ $filters.currencyUSD(0) }}
											</span>
										</span>

										<!-- IF CREDIT NOTE, THE BALANCE NEEDS TO INCLUDE THE GROWTH BONUS -->

										<span v-else>
											{{ $filters.currencyUSD(0) }}
										</span>
										</dd>
								</v-row>
								</dl>

								<div class="pa-2 bg-color-quartz tx-color-white tx-font-bold text-center">
									<v-row class="d-flex justify-center">
										<v-col :cols="(redemptionsBalance >= 50 || redemptionsTotal >= 50) && (redemptionWindowOpen && redemptionsCreditedProcess === 'EVoucher' && !IsPassthroughCountry) ? 6 : 12">
											<v-btn class="text-none bg-color-dell-blue" block @click="systemStore.routerTo('partner-rewards-paid')" @keydown.enter="systemStore.routerTo('partner-rewards-paid')" aria-label="View rewards payment details" tabindex="0" role="link">
												<LanguagePlaceholder default-text="View More" />
											</v-btn>  
										</v-col>
										<v-col cols="6" v-if="(redemptionsBalance >= 50 || redemptionsTotal >= 50) && (redemptionWindowOpen && redemptionsCreditedProcess === 'EVoucher' && !IsPassthroughCountry)">													
											<v-btn 
												class="text-none bg-color-royal" 
												block 
												@click="systemStore.routerTo('redemption')"
												role="link"
												@keydown.enter="systemStore.routerTo('redemption')"
												aria-label="Redeem my rewards now"
												tabindex="0">
												<LanguagePlaceholder default-text="Redeem" />
											</v-btn>  
										</v-col>
									</v-row>
								</div>
							</v-col>
						</v-row>
					</v-sheet>
					<v-sheet class="d-flex flex-column bg-color-quartz mt-auto" id="my-bonuses">
						<div class="pa-2 bg-color-white tx-color-royal tx-font-bold text-center">
							<h2><LanguagePlaceholder default-text="My Bonuses" /></h2>
						</div>
						<div class="flex: 1 px-2 bg-color-quartz tx-color-steel text-start tx-font-bold tx-font-size14">
							<v-data-table 
								density="compact"
								hide-default-footer 
								items-per-page="50" 
								:headers="headers" 
								:items="bonusData"
								item-key="id" 
								class="v-data-table-row ma-0 pa-0 w-100"
								style="min-height: 250px;"
								role="table"
								aria-label="Bonus qualification status table"
							>
									<template v-slot:item.quarter="{ item }">
											<span>{{ currentRedemptionQuarter }}</span>
									</template>
							</v-data-table>   
						</div>
						<div class="pa-2 pt-1 bg-color-quartz tx-color-white tx-font-bold text-center">
							<v-btn class="text-none w-100 bg-color-dell-blue" @click="systemStore.routerTo('bonus-dashboard-partner')" @keydown.enter="systemStore.routerTo('bonus-dashboard-partner')" aria-label="View bonus dashboard details" tabindex="0" role="link">
								<LanguagePlaceholder default-text="View More" />
							</v-btn>    
						</div>
					</v-sheet>
				</v-col>

				<v-col class="ga-2 d-flex flex-column">
					<v-sheet class="d-flex flex-column" id="rewards-calculator">
						<div class="pa-2 bg-color-white tx-color-royal tx-font-bold text-center">
							<h2><LanguagePlaceholder default-text="Rewards Calculator" /></h2>
						</div>
						<div class="px-4 pt-4 pb-2 bg-color-quartz tx-color-steel text-start tx-font-bold tx-font-size14">
							<LanguagePlaceholder is-html default-text="Calculate how many $ rewards you could earn this incentive period based on forecast purchases." />
						</div>
						<div class="d-flex justify-center pa-2 bg-color-quartz tx-color-white">
							<v-img class="d-flex justify-center align-center" cover
								src="https://dellpartnerincentives.com/siteassets/Images/HomePartner/RewardsCalculator.jpg"
								alt=""
							></v-img>
						</div>
						<div class="pa-2 bg-color-quartz tx-color-white tx-font-bold text-center">
							<v-btn class="text-none w-100 bg-color-dell-blue" @click="systemStore.routerTo('rewards-calculator')" @keydown.enter="systemStore.routerTo('rewards-calculator')" aria-label="Calculate potential rewards now" tabindex="0" role="link">
								<LanguagePlaceholder default-text="Calculate Now" />
							</v-btn>  
						</div>
					</v-sheet>
					<v-sheet class="d-flex flex-column bg-color-quartz mt-auto" style="min-height: 470px;" id="help-center">
						<div class="pa-2 bg-color-white tx-color-royal tx-font-bold text-center">
							<h2><LanguagePlaceholder default-text="Help Center" /></h2>
						</div>
					<ul class="px-4 pt-2 pb-2 bg-color-quartz list-unstyled ma-0" style="list-style: none; padding-left: 1rem;">
						<li class="pb-1 tx-color-steel text-start tx-font-bold tx-font-size14">
							<LanguagePlaceholder is-html default-text="<route route-name='faq' style='text-decoration: underline;' tabindex='0' role='link' aria-label='Go to Frequently Asked Questions'>Frequently Asked Questions</route>" />
						</li>
						<li class="py-1 tx-color-steel text-start tx-font-bold tx-font-size14">
							<LanguagePlaceholder is-html default-text="<route route-name='faq' style='text-decoration: underline;' tabindex='0' role='link' aria-label='Go to User Guide'>User Guide</route>" />
						</li>
						<li class="pt-1 tx-color-steel text-start tx-font-bold tx-font-size14">
							<LanguagePlaceholder is-html default-text="<route route-name='contact-us' style='text-decoration: underline;' tabindex='0' role='link' aria-label='Go to Contact Support'>Contact Support</route>" />
						</li>
					</ul>
						<div class="d-flex justify-center pa-2 bg-color-quartz tx-color-white">
							<v-img class="d-flex justify-center align-center" cover 
								src="https://dellpartnerincentives.com/siteassets/Images/HomePartner/HelpCentre.jpg"
								alt=""
							></v-img>
						</div>
					</v-sheet>
				</v-col>
			</v-row>
		</v-container>		
	</div>
</template>

<script setup>
import { watch, ref, computed, onMounted } from 'vue'
import { useSystemStore } from '@/stores/system'
import LanguagePlaceholder from '@/components/LanguagePlaceholder.vue'
import Carousel from '@/components/Carousel.vue'
import { useReportsStore } from '@/stores/reports'
import { useUserStore } from '@/stores/user'

const systemStore = useSystemStore()
const reportsStore = useReportsStore()
const userStore = useUserStore()
const carouselOneItems = ref([])

carouselOneItems.value = [    
		{
			item: 1,
			url: 'https://dellpartnerincentives.com/siteassets/Images/HomePartner/HomePartnerCarousel1_16.gif',
			title: '',
			ariaLabel: 'Open DNCP page',
			isClickable: true,
			route: 'dncp',
			customLanguageContent: {
				'en': {
					imgUrl: 'https://dellpartnerincentives.com/siteassets/Images/HomePartner/HomePartnerCarousel1_16.gif',
					clickEvent: () => systemStore.routerTo('dncp')
				},
			}
		},
		// {
		// 	item: 1,
		// 	url: 'https://dellpartnerincentives.com/siteassets/Images/HomePartner/HomePartnerCarousel1_13.jpg',
		// 	title: '',
		// 	ariaLabel: 'Open Survey',
		// 	isClickable: true,
		// 	customLanguageContent: {
		// 		'en': {
		// 			imgUrl: 'https://dellpartnerincentives.com/siteassets/Images/HomePartner/HomePartnerCarousel1_13.jpg',
		// 			clickEvent: () => systemStore.openUrl('https://forms.office.com/r/vxjDeGpJZd')
		// 		},
		// 	}
		// },
		// {
		// 	item: 2,
		// 	url: 'https://dellpartnerincentives.com/siteassets/Images/HomePartner/HomePartnerCarousel1_3.jpg',
		// 	title: '',
		// 	ariaLabel: 'Open CSG Webinar Series PDF',
		// 	isClickable: true,
		// 	route: 'news',
		// 	customLanguageContent:{
		// 		'en': {
		// 				imgUrl: 'https://dellpartnerincentives.com/siteassets/Images/HomePartner/HomePartnerCarousel1_3.jpg',
		// 				clickEvent: () => systemStore.openUrl('https://www.dellpartnerincentives.com/resources/Dell%20Technologies/CSG%20Webinar%20Series.pdf')
		// 		},
		// 	}
		// },
		// {
		// 	item: 2,
		// 	url: 'https://dellpartnerincentives.com/siteassets/Images/HomePartner/HomePartnerCarousel1_15.jpg',
		// 	title: '',
		// 	ariaLabel: 'Open CSG Webinar Series PDF',
		// 	isClickable: true,
		// 	route: 'news',
		// 	customLanguageContent:{
		// 		'en': {
		// 				imgUrl: 'https://dellpartnerincentives.com/siteassets/Images/HomePartner/HomePartnerCarousel1_15.jpg',
		// 				clickEvent: () => systemStore.openUrl('https://dell.zoom.us/webinar/register/WN_7hnb57GES7aun7ks66RAdw')
		// 		},
		// 	}
		// },
		/*{
			item: 3,
			url: 'https://dellpartnerincentives.com/siteassets/Images/HomePartner/HomePartnerCarousel1_14.jpg',
			title: '',
			ariaLabel: 'Open CSG Webinar Series PDF',
			isClickable: true,
			route: 'news',
			customLanguageContent:{
				'en': {
						imgUrl: 'https://dellpartnerincentives.com/siteassets/Images/HomePartner/HomePartnerCarousel1_14.jpg',
						clickEvent: () => systemStore.openUrl('https://dell.zoom.us/webinar/register/WN_jucPxI3nQj2UEnmp9gwreg#/registration')
				},
			}
		},*/
	]
 



const getImageUrl = () => {
	switch (systemStore.selectedLanguage) {
		case 'FR':
			return 'https://dellpartnerincentives.com/siteassets/Images/HomePartner/Banner/bgRISE2.jpg'
		case 'DE':
			return 'https://dellpartnerincentives.com/siteassets/Images/HomePartner/Banner/bgRISE2_AW.jpg'
		default:
			return 'https://dellpartnerincentives.com/siteassets/Images/HomePartner/Banner/bgRISE2.jpg'
	}
}

const bonusData = ref([])
const bonusReport = ref({})
const userId = ref(0)
const headers = ref([
	{
		title: `Quarter`,
		value: `quarter`,
		headerProps: { class: 'v-data-table-header', scope: 'col' },
		sortable: false
	},
	{
		title: `Bonus Name`,
		value: `bonusName`,
		headerProps: { class: 'v-data-table-header', scope: 'col' },
		sortable: false
	},
	{
		title: `Bonus Value`,
		value: `bonusValue`,
		headerProps: { class: 'v-data-table-header', scope: 'col' },
		sortable: false
	},
	{
		title: `Current Units`,
		value: `units`,
		headerProps: { class: 'v-data-table-header', scope: 'col' },
		sortable: false
	},
	{
		title: `Threshold`,
		value: `unitThresholdAndRewardValue`,
		headerProps: { class: 'v-data-table-header', scope: 'col' },
		sortable: false
	},
	{
		title: `Qualified`,
		value: `qualified`,
		headerProps: { class: 'v-data-table-header', scope: 'col' },
		sortable: false
	}
])

const quarters = ref([])
const currentQuarter = ref('')
const currentRedemptionQuarter = ref('')
const myPerformanceData = ref({})
const totalDollarCoreRewards = ref(0)
const totalDollarBonusRewards = ref(0)
const myUnits = ref(0)
const redemptionSummaryData = ref({})
const redemptionsCredited = ref(0)
const redemptionsBalance = ref(0)
const redemptionsCreditedProcess = ref('')
const redemptionWindowOpen = ref(false)
const redemptionsTotal = ref(0)
const IsPassthroughCountry = ref(false)

onMounted(() => {
	if (systemStore.userDetail?.country === 'France') {
		carouselOneItems.value.push({
			item: 2,
			url: 'https://dellpartnerincentives.com/siteassets/Images/HomePartner/HomePartnerCarousel1_17.jpg',
			title: '',
			ariaLabel: 'Open DNCP page',
			isClickable: true,
			route: 'dncp',
			customLanguageContent: {
				'en': {
					imgUrl: 'https://dellpartnerincentives.com/siteassets/Images/HomePartner/HomePartnerCarousel1_17.png',
					clickEvent: () => systemStore.openUrl('https://www.dellpartnerincentives.com/comms/FY27Q4/French%20HTML/rise_landing_promos_sns%20(3).html')
				},
			}
		})
	}

	// if (systemStore.selectedLanguage === 'fr') {
	// 	carouselOneItems.value.push({
	// 		item: 6,
	// 		url: 'https://dellpartnerincentives.com/siteassets/Images/HomePartner/HomePartnerCarousel1_6_FR.png',
	// 		title: '',
	// 		isClickable: true,
	// 		route: 'news',
	// 		customLanguageContent: {
	// 			'fr': {
	// 				imgUrl: 'https://dellpartnerincentives.com/siteassets/Images/HomePartner/HomePartnerCarousel1_6_FR.png',
	// 				clickEvent: () => systemStore.openUrl('https://dell.zoom.us/webinar/register/WN_5_HGNGqFROiIZfH5_h1t0Q')
	// 			}
	// 		}
	// 	})
	// }	
	// if (systemStore.userDetail.userType === 'Partner' || systemStore.userDetail.userType === 'TIC_Admin' || systemStore.userDetail.userType === 'TP' || systemStore.userDetail.userType === 'PAM' || systemStore.userDetail.userType === 'Dell Marketing') {
	// 	carouselOneItems.value.push(
	// 		// {
	// 		// item: 4,
	// 		// url: 'https://dellpartnerincentives.com/siteassets/Images/HomePartner/HomePartnerCarousel1_10.jpg',
	// 		// title: '',
	// 		// isClickable: true,
	// 		// route: 'news',
	// 		// customLanguageContent:{
	// 		// 	'en': {
	// 		// 			imgUrl: 'https://dellpartnerincentives.com/siteassets/Images/HomePartner/HomePartnerCarousel1_10.jpg',
	// 		// 			clickEvent: () => systemStore.openUrl('https://www.emearewardshub.com/Dashboard/Campaign?id=5826')
	// 		// 		},
	// 		// 	}
	// 		// }
	// 		{
	// 		item: 3,
	// 		url: 'https://dellpartnerincentives.com/siteassets/Images/HomePartner/HomePartnerCarousel1_11.jpg',
	// 		title: '',
	// 		isClickable: true,
	// 		route: 'news',
	// 		customLanguageContent:{
	// 			'en': {
	// 					imgUrl: 'https://dellpartnerincentives.com/siteassets/Images/HomePartner/HomePartnerCarousel1_11.jpg',
	// 					clickEvent: () => systemStore.openUrl('https://dell.zoom.us/webinar/register/WN_OhK1YBMuTamjTgjge_8spg#/registration')
	// 				},
	// 			}
	// 		}
	// 	)
	// }	


	isRedemptionWindowOpen()

	systemStore.getQuarters().then(result => {
    if (result.success) {
		
      quarters.value = result.quarters
      	.filter(q => q.currentQuarters === true)
      	.map(q => q.quarter)
			

			currentQuarter.value = result.quarters.find(q => q.currentQuarter === true)?.quarter

			systemStore.getMyPerformanceData(systemStore.userDetail.affinityId, currentQuarter.value).then(result => {
				myPerformanceData.value = result
				totalDollarCoreRewards.value = myPerformanceData.value.totalDollarCoreRewards
				totalDollarBonusRewards.value = myPerformanceData.value.totalDollarBonusRewards
				myUnits.value = myPerformanceData.value.csG_UnitsCountTowardThreshold_ThisPeriod + myPerformanceData.value.server_UnitsCountTowardThreshold_ThisPeriod + myPerformanceData.value.storage_UnitsCountTowardThreshold_ThisPeriod
			})



			currentRedemptionQuarter.value = result.quarters.find(q => q.currentRedemptionQuarter === true)?.quarter
			
			systemStore.getMyPerformanceData(systemStore.userDetail.affinityId, currentRedemptionQuarter.value).then(result => {
        		redemptionSummaryData.value = result
			 	redemptionsCredited.value = redemptionSummaryData.value.totalDollarRewards

				if (redemptionsCredited.value > 15000) {
					redemptionsCredited.value = 15000
					redemptionsBalance.value = 15000
				}
				

				systemStore.getRewardsAccountData(currentRedemptionQuarter.value).then(result => {
					redemptionSummaryData.value = result
					if (redemptionSummaryData.value.openingBalance > 0) {
						redemptionsBalance.value = redemptionSummaryData.value.balance + redemptionSummaryData.value.banked

						if (Math.abs(Math.round(redemptionsBalance.value * 100) - Math.round(redemptionsCredited.value * 100)) === 1) {
							redemptionsCredited.value = redemptionsBalance.value
						}

					}
					else {
						redemptionsBalance.value = redemptionsCredited.value
					}
					
					IsPassthroughCountry.value = redemptionSummaryData.value.isPassthroughCountry
					redemptionsCreditedProcess.value = IsPassthroughCountry.value ? 'Credit Note' : 'EVoucher'

					redemptionsTotal.value = (redemptionSummaryData.value.banked + redemptionsCredited.value) - redemptionSummaryData.value.rewardsRedeemed
				})

    	})

			userStore.getUserId().then(result => {
        		userId.value = result.responseData  
				getBonusReportTemplate()
    	})			
		}
  })
})


const getBonusReportTemplate = () => {
    reportsStore.getReports(':BonusReport:').then(result => {
    if (result.success === true) {
        if (result.hasData) {
          bonusReport.value = JSON.parse(result.reportData)[0];
          if (bonusReport.value.Params.length > 0) {
            bonusReport.value.Params = JSON.parse(bonusReport.value.Params) 
						getReportData()
          }
       }
    }
  }).catch(error => {
      console.log(`getBonusReportTemplate`, error)
  })
}

const getReportData = () => {

    if (bonusReport.value.Params.length > 0) {
			bonusReport.value.Params.forEach((p) => {
            if (p.Name === 'Quarter') {
                p.Value = currentRedemptionQuarter.value
            }
            else if (p.Name === 'UserId') {
                p.Value = userId.value
            }
        })
    }

    bonusData.value = []

    reportsStore.getReportData(bonusReport.value, false, false).then(result => {
			if (result.success === true) {
					if (result.hasData) {
						var arr = JSON.parse(result.reportData)
						if (!arr || arr.length === 0) {
							bonusData.value = [];
						} else if (arr.length === 1) {
							bonusData.value = [arr[0]]
						} else {
							bonusData.value = arr.slice(0, 2);
						}
						if (bonusData.value.length > 0) {
							bonusData.value.forEach(item => {
								if (item["bonusName"] == 'Growth Bonus') {
									item["units"] = "-"
								}
							})
						}
					}            
			}
		})
}

const isRedemptionWindowOpen = () => {
    systemStore.getAutoRedemptionState().then(result => {
        redemptionWindowOpen.value = result.autoRedemptionState
        //redemptionWindowOpen.value = true
    }).catch(error => {
      console.log('getAutoRedemptionState', error)
    })
}


</script>

<style scoped>

/* Screen reader only class for live regions */
.sr-only {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border: 0;
}

/* WCAG 2.4.7 / 1.4.11 Focus Indicators — dual-ring pattern:
   outer ring: #003785 dark navy (~9:1 vs white/quartz, ~5:1 vs granite)
   inner halo: #FFFFFF white  (~4.6:1 vs blue button bg)
   Meets 3:1 non-text contrast on all page backgrounds. */

/* Primary focus indicator for all keyboard-accessible elements */
:deep(*:focus-visible) {
  outline: 3px solid #003785 !important;
  outline-offset: 4px !important;
  box-shadow: 0 0 0 4px #FFFFFF !important;
  position: relative !important;
  z-index: 100 !important;
}

/* Buttons - dual ring: dark outline contrasts with light page bg */
:deep(.v-btn:focus-visible) {
  outline: 3px solid #003785 !important;
  outline-offset: 4px !important;
  box-shadow: 0 0 0 4px #FFFFFF !important;
}

/* Blue/royal buttons: inner white ring + dark outer ring */
:deep(.v-btn.bg-color-dell-blue:focus-visible),
:deep(.v-btn.bg-color-royal:focus-visible),
:deep(.v-btn.bg-color-cobalt:focus-visible) {
  outline: 3px solid #003785 !important;
  outline-offset: 4px !important;
  box-shadow: 0 0 0 4px #FFFFFF !important;
}

/* Links */
:deep(a:focus-visible) {
  outline: 3px solid #003785 !important;
  outline-offset: 2px !important;
  box-shadow: 0 0 0 4px #FFFFFF !important;
  text-decoration: underline !important;
  border-radius: 2px !important;
}

/* Data table rows */
:deep(.v-data-table tbody tr:focus-visible) {
  outline: 3px solid #003785 !important;
  outline-offset: -2px !important;
  background-color: rgba(0, 55, 133, 0.08) !important;
}

/* Table cells */
:deep(.v-data-table td:focus-visible),
:deep(.v-data-table th:focus-visible) {
  outline: 3px solid #003785 !important;
  outline-offset: -1px !important;
}

/* Custom tabindex elements */
:deep([tabindex="0"]:focus-visible) {
  outline: 3px solid #003785 !important;
  outline-offset: 4px !important;
  box-shadow: 0 0 0 4px #FFFFFF !important;
}

/* Images when keyboard focusable */
:deep(.v-img:focus-visible) {
  outline: 3px solid #003785 !important;
  outline-offset: 4px !important;
  box-shadow: 0 0 0 4px #FFFFFF !important;
}

/* Icons when keyboard focusable */
:deep(.v-icon:focus-visible) {
  outline: 3px solid #003785 !important;
  outline-offset: 3px !important;
  box-shadow: 0 0 0 4px #FFFFFF !important;
  border-radius: 4px !important;
}

/* Cards and sheets when focusable */
:deep(.v-card:focus-visible),
:deep(.v-sheet:focus-visible) {
  outline: 4px solid #0066CC !important;
  outline-offset: 2px !important;
  box-shadow: 0 0 0 7px rgba(0, 102, 204, 0.35) !important;
}

/* Interactive regions with role attributes */
:deep([role="button"]:focus-visible),
:deep([role="link"]:focus-visible),
:deep([role="tab"]:focus-visible) {
  outline: 3px solid #003785 !important;
  outline-offset: 4px !important;
  box-shadow: 0 0 0 4px #FFFFFF !important;
}

/* List items when keyboard navigable */
:deep(li:focus-visible) {
  outline: 3px solid #003785 !important;
  outline-offset: 2px !important;
  box-shadow: 0 0 0 2px #FFFFFF !important;
}

/* Form controls focus */
:deep(input:focus-visible),
:deep(select:focus-visible),
:deep(textarea:focus-visible) {
  outline: 3px solid #003785 !important;
  outline-offset: 2px !important;
  box-shadow: 0 0 0 4px #FFFFFF !important;
}

/* Vuetify specific input fields */
:deep(.v-input:focus-within),
:deep(.v-field:focus-within) {
  outline: 3px solid #003785 !important;
  outline-offset: 2px !important;
  box-shadow: 0 0 0 2px #FFFFFF !important;
}

/* Checkboxes and radio buttons */
:deep(.v-checkbox:focus-visible),
:deep(.v-radio:focus-visible) {
  outline: 3px solid #003785 !important;
  outline-offset: 3px !important;
  box-shadow: 0 0 0 4px #FFFFFF !important;
}

/* Select dropdowns */
:deep(.v-select:focus-visible) {
  outline: 3px solid #003785 !important;
  outline-offset: 2px !important;
  box-shadow: 0 0 0 4px #FFFFFF !important;
}

/* Pagination controls */
:deep(.v-pagination__item:focus-visible) {
  outline: 3px solid #003785 !important;
  outline-offset: 2px !important;
  box-shadow: 0 0 0 4px #FFFFFF !important;
}

/* Menu items */
:deep(.v-list-item:focus-visible) {
  outline: 3px solid #003785 !important;
  outline-offset: -2px !important;
  background-color: rgba(0, 55, 133, 0.08) !important;
}

/* Tabs */
:deep(.v-tab:focus-visible) {
  outline: 3px solid #003785 !important;
  outline-offset: 3px !important;
  box-shadow: 0 0 0 4px #FFFFFF !important;
}

/* Carousel navigation buttons */
:deep(.v-carousel__controls__item:focus-visible) {
  outline: 3px solid #003785 !important;
  outline-offset: 2px !important;
  box-shadow: 0 0 0 4px #FFFFFF !important;
}

/* Dialog/Modal close buttons */
:deep(.v-dialog .v-btn:focus-visible) {
  outline: 3px solid #003785 !important;
  outline-offset: 3px !important;
  box-shadow: 0 0 0 4px #FFFFFF !important;
}

/* Accordion/Expansion panel headers */
:deep(.v-expansion-panel-title:focus-visible) {
  outline: 3px solid #003785 !important;
  outline-offset: -2px !important;
  box-shadow: 0 0 0 2px #FFFFFF !important;
}

/* Chips */
:deep(.v-chip:focus-visible) {
  outline: 3px solid #003785 !important;
  outline-offset: 2px !important;
  box-shadow: 0 0 0 4px #FFFFFF !important;
}

/* Slider controls */
:deep(.v-slider:focus-visible),
:deep(.v-slider__thumb:focus-visible) {
  outline: 3px solid #003785 !important;
  outline-offset: 3px !important;
  box-shadow: 0 0 0 4px #FFFFFF !important;
}

/* Switch/Toggle controls */
:deep(.v-switch:focus-visible) {
  outline: 3px solid #003785 !important;
  outline-offset: 3px !important;
  box-shadow: 0 0 0 4px #FFFFFF !important;
}

/* Tooltips when focusable */
:deep(.v-tooltip:focus-visible) {
  outline: 3px solid #003785 !important;
  box-shadow: 0 0 0 4px #FFFFFF !important;
}

/* Badge elements when focusable */
:deep(.v-badge:focus-visible) {
  outline: 3px solid #003785 !important;
  outline-offset: 2px !important;
  box-shadow: 0 0 0 4px #FFFFFF !important;
}

/* Dividers */
:deep(hr:focus-visible),
:deep(.v-divider:focus-visible) {
  outline: 3px solid #003785 !important;
  outline-offset: 2px !important;
}

/* Remove default browser focus outline to prevent double outlines */
:deep(*:focus:not(:focus-visible)) {
  outline: none !important;
}

/* Ensure focus indicators are never clipped */
:deep(*:focus-visible) {
  overflow: visible !important;
}

/* High contrast mode support */
@media (prefers-contrast: high) {
  :deep(*:focus-visible) {
    outline-width: 4px !important;
    outline-color: #000000 !important;
    box-shadow: 0 0 0 4px #FFFFFF !important;
  }
}

/* Reduced motion support */
@media (prefers-reduced-motion: reduce) {
  :deep(*:focus-visible) {
    transform: none !important;
    transition: none !important;
  }
}


/* WCAG 2.0 Color Contrast Improvements */

/* Ensure steel text on quartz background meets contrast requirements */
.tx-color-steel {
  color: #2C2C2C !important; /* Darker steel for better contrast */
}

/* Ensure carbon text on quartz background meets contrast requirements */
.tx-color-carbon {
  color: #1A1A1A !important; /* Darker carbon for better contrast */
}

/* Ensure royal text on white background meets contrast requirements */
.tx-color-royal {
  color: #003366 !important; /* Darker royal for better contrast */
}

/* High contrast mode support for text colors */
@media (prefers-contrast: high) {
  .tx-color-steel {
    color: #000000 !important;
  }
  
  .tx-color-carbon {
    color: #000000 !important;
  }
  
  .tx-color-royal {
    color: #000080 !important;
  }
}
</style>
